(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-product"]) return;
  try {
    
document.addEventListener("click",function(event){const arrow=event.target.closest("[data-gallery-step]");if(!arrow)return;const gallery=arrow.closest(".gallery");const dots=Array.from(gallery.querySelectorAll("[data-media-target]"));if(dots.length<2)return;const current=Math.max(0,dots.findIndex(dot=>dot.getAttribute("aria-pressed")==="true"));const next=(current+Number(arrow.dataset.galleryStep)+dots.length)%dots.length;dots[next].click();});

  } catch(e) { console.error(e); }
})();
})();
